<template>
    <div class="w1200 audition-page" v-loading="loading">
        <div class="audition-type" style="margin-bottom:16px;">
            <div class="desc">方案详情</div>
            <div class="actions">
                <span class="apply_sss" @click="goBack">返回栏目</span>
            </div>
        </div>

        <template v-if="detail">
            <entry-detail-panel
                :entry="detail"
                :lottery-options="lotteryOptions"
                :downloading="downloading"
                @download="handleDownload" />

            <div class="audition-action-box">
                <div class="box-title">跟单意向</div>
                <div class="follow-row">
                    <template v-if="detail.periodOperable">
                        <el-button
                            v-if="loggedIn && !detail.followIntented"
                            plain
                            class="audition-follow-cancel-btn"
                            @click="handleFollow">表达跟单意向</el-button>
                        <el-button
                            v-else-if="detail.followIntented"
                            plain
                            class="audition-follow-cancel-btn"
                            :loading="followCanceling"
                            @click="handleCancelFollow">取消跟单意向</el-button>
                    </template>
                    <el-tag v-else type="info">本期已截止</el-tag>

                    <span class="follow-count">
                        跟单意向：{{ detail.followIntentCount || 0 }} / {{ followThreshold }} 人
                    </span>
                    <el-tag v-if="detail.canInitCrowdfunding" type="warning">已达跟单阈值</el-tag>
                </div>
                <div class="follow-row" v-if="detail.canInitCrowdfunding" style="margin-top: 12px;">
                    <el-button type="primary" :loading="converting" @click="openCrowdfund">转为众筹招股</el-button>
                    <span class="follow-count">跟单意向达阈值后可发起众筹，向散户募集实战票资金</span>
                </div>
            </div>

            <!-- 海选转众筹招股 -->
            <el-dialog title="发起众筹招股" :visible.sync="crowdfundDialog" width="560px">
                <el-form label-width="110px" :model="crowdfundForm">
                    <el-form-item label="众筹标题">
                        <el-input v-model="crowdfundForm.title" placeholder="不填则取海选方案标题"></el-input>
                    </el-form-item>
                    <el-form-item label="彩票期号" required>
                        <el-input v-model="crowdfundForm.issueNumber" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="彩种" required>
                        <el-input :value="preTypeLabelOf(crowdfundForm.lotteryType)" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="出票站号" required>
                        <el-input v-model="crowdfundForm.bettingShopNumber" placeholder="请输入出票站号"></el-input>
                    </el-form-item>
                    <el-form-item label="出票站点" required>
                        <el-input v-model="crowdfundForm.bettingShopAddress" placeholder="请输入出票站点"></el-input>
                    </el-form-item>
                    <el-form-item label="众筹总额(元)" required>
                        <el-input-number v-model="crowdfundForm.crowdfundingAmount" :min="1" :precision="2" controls-position="right" style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="众筹总股数" required>
                        <el-input-number v-model="crowdfundForm.crowdfundingNumber" :min="1" :step="1" controls-position="right" style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="每股价格(缩币)" required>
                        <el-input-number v-model="crowdfundForm.crowdfundingPrice" :min="1" :precision="2" controls-position="right" style="width: 100%"></el-input-number>
                    </el-form-item>
                    <el-form-item label="每人认购上限">
                        <el-input-number v-model="crowdfundForm.personLimit" :min="0" :step="1" controls-position="right" style="width: 100%"></el-input-number>
                        <div class="form-tip">0 或不填则后端按 min(总股数,100) 设定</div>
                    </el-form-item>
                    <el-form-item label="众筹说明">
                        <el-input v-model="crowdfundForm.explanation" type="textarea" :rows="3" placeholder="选填"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer">
                    <el-button @click="crowdfundDialog = false">取消</el-button>
                    <el-button type="primary" :loading="converting" @click="submitCrowdfund">确认发起</el-button>
                </span>
            </el-dialog>
        </template>
    </div>
</template>

<script>
import { getEntryDetail, followIntent, cancelFollowIntent, getCurrentPeriod, downloadEntry, initAuditionCrowdfunding } from '@/api/audition'
import { queryLotteryType } from '@/api/common'
import EntryDetailPanel from './components/EntryDetailPanel.vue'
import { filterAuditionLotteryOptions, hxwyszHomeLocation } from './utils'

export default {
    components: { EntryDetailPanel },
    data () {
        return {
            loading: false,
            downloading: false,
            detail: null,
            lotteryOptions: [],
            followThreshold: 50,
            followCanceling: false,
            crowdfundDialog: false,
            converting: false,
            crowdfundForm: {
                title: '',
                issueNumber: '',
                lotteryType: '',
                bettingShopNumber: '',
                bettingShopAddress: '',
                crowdfundingAmount: 1000,
                crowdfundingNumber: 100,
                crowdfundingPrice: 10,
                personLimit: 0,
                explanation: '',
                scheme: null
            }
        }
    },
    computed: {
        loggedIn () {
            return !!this.vuex_token
        }
    },
    mounted () {
        this.loadLotteryTypes()
        this.loadDetail()
    },
    methods: {
        goBack () {
            const preType = (this.detail && this.detail.preType) || this.$route.query.preType
            this.$router.push(hxwyszHomeLocation(preType))
        },
        loadLotteryTypes () {
            queryLotteryType().then(res => {
                if (res.code === 200) {
                    this.lotteryOptions = filterAuditionLotteryOptions(res.data)
                }
            })
        },
        loadPeriodThreshold (preType) {
            if (!preType) return
            getCurrentPeriod(preType).then(res => {
                if (res.code === 200 && res.data) {
                    this.followThreshold = res.data.followIntentThreshold || 50
                }
            })
        },
        loadDetail () {
            this.loading = true
            getEntryDetail(this.$route.params.id).then(res => {
                if (res.code === 200) {
                    this.detail = res.data
                    this.loadPeriodThreshold(this.detail.preType)
                } else {
                    this.$message.error(res.msg || '加载失败')
                }
                this.loading = false
            }).catch(() => { this.loading = false })
        },
        goLogin () {
            this.$router.push('/login?redirect=' + encodeURIComponent(this.$route.fullPath))
        },
        handleFollow () {
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            followIntent(this.detail.id).then(res => {
                if (res.code === 200) {
                    this.$message.success((res.header && res.header.msg) || res.msg || '已表达跟单意向')
                    this.loadDetail()
                } else {
                    this.$message.error(res.msg || '操作失败')
                }
            })
        },
        handleCancelFollow () {
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            this.$confirm('确定取消跟单意向吗？', '提示', { type: 'warning' }).then(() => {
                this.followCanceling = true
                cancelFollowIntent(this.detail.id).then(res => {
                    if (res.code === 200) {
                        this.$message.success((res.header && res.header.msg) || res.msg || '已取消跟单意向')
                        this.loadDetail()
                    } else {
                        this.$message.error(res.msg || '操作失败')
                    }
                    this.followCanceling = false
                }).catch(() => { this.followCanceling = false })
            }).catch(() => {})
        },
        handleDownload () {
            if (!this.detail || !this.detail.id) return
            this.downloading = true
            downloadEntry(this.detail.id).then(res => {
                if (!res || !(res instanceof Blob)) {
                    this.$message.error('下载失败，请稍后重试')
                    this.downloading = false
                    return
                }
                res.arrayBuffer().then(buffer => {
                    const bytes = new Uint8Array(buffer)
                    if (bytes.length >= 2 && bytes[0] === 0x50 && bytes[1] === 0x4B) {
                        this.$message.error('服务未更新，下载内容异常，请联系管理员')
                        this.downloading = false
                        return
                    }
                    let fileName = this.detail.attachmentFileName
                    if (!fileName) {
                        const base = (this.detail.title || '海选方案').replace(/[\\/:*?"<>|]/g, '_')
                        fileName = base + '.txt'
                    }
                    this.$utils.downloadFile(bytes, fileName, 'text/plain;charset=utf-8')
                    this.downloading = false
                }).catch(() => {
                    this.$message.error('下载失败，请稍后重试')
                    this.downloading = false
                })
            }).catch(() => {
                this.$message.error('下载失败，请稍后重试')
                this.downloading = false
            })
        },
        openCrowdfund () {
            if (!this.detail) return
            if (!this.loggedIn) {
                this.goLogin()
                return
            }
            this.crowdfundForm = {
                title: this.detail.title || '',
                issueNumber: this.detail.issueNumber || '',
                lotteryType: this.detail.preType || '',
                bettingShopNumber: '',
                bettingShopAddress: '',
                crowdfundingAmount: 1000,
                crowdfundingNumber: 100,
                crowdfundingPrice: 10,
                personLimit: 0,
                explanation: '',
                // 海选桥接：scheme 校验要求非空，默认取海选方案 id（后端以 entryId 维系真实关联）
                scheme: this.detail.id
            }
            this.crowdfundDialog = true
        },
        preTypeLabelOf (preType) {
            if (!preType) return '-'
            const item = this.lotteryOptions.find(o => o.dictValue === preType)
            return item ? item.dictLabel : preType
        },
        submitCrowdfund () {
            const f = this.crowdfundForm
            if (!f.issueNumber || !f.lotteryType || !f.bettingShopNumber || !f.bettingShopAddress) {
                this.$message.warning('请补全出票站号、站点等必填项')
                return
            }
            if (!f.crowdfundingAmount || f.crowdfundingAmount <= 0
                || !f.crowdfundingNumber || f.crowdfundingNumber < 1
                || !f.crowdfundingPrice || f.crowdfundingPrice <= 0) {
                this.$message.warning('请填写合法的众筹总额/股数/每股价格')
                return
            }
            this.converting = true
            const body = {
                title: f.title,
                issueNumber: f.issueNumber,
                lotteryType: f.lotteryType,
                scheme: f.scheme,
                bettingShopNumber: f.bettingShopNumber,
                bettingShopAddress: f.bettingShopAddress,
                crowdfundingAmount: f.crowdfundingAmount,
                crowdfundingNumber: f.crowdfundingNumber,
                crowdfundingPrice: f.crowdfundingPrice,
                personLimit: f.personLimit > 0 ? f.personLimit : null,
                explanation: f.explanation,
                auditionEntryId: this.detail.id
            }
            initAuditionCrowdfunding(this.detail.id, body)
                .then((res) => {
                    if (res && res.code === 200) {
                        this.$message.success((res.header && res.header.msg) || res.msg || '已发起众筹招股')
                        this.crowdfundDialog = false
                        this.$router.push('/sttzzbfzx/zhaogu')
                    } else {
                        this.$message.error((res && res.msg) || '发起失败')
                    }
                    this.converting = false
                })
                .catch(() => { this.converting = false })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./audition.scss";

.form-tip {
    color: #909399;
    font-size: 12px;
    line-height: 1.4;
    margin-top: 2px;
}
</style>
